import React, { useRef } from 'react';

import { RelevosProductCategoryWithImage } from '../../../../../api/types';
import { ConfirmDialogBody } from '../../../../../common/components/ConfirmationDialog/ConfirmDialogBody';
import Dialog from '../../../../../common/components/ConfirmationDialog/Dialog';
import { useTranslations } from '../../../../../contexts/LocalizationContext';

type UnknownItemsConfirmModalProps = {
  isOpen: boolean;
  handleClose: () => void;
  onConfirm: () => void;
  confirmText: string;
  confirmButtonText: string;
  children: React.ReactNode;
  categories?: RelevosProductCategoryWithImage[];
};

export const UnknownItemsConfirmModal = ({
  isOpen,
  handleClose,
  onConfirm,
  confirmButtonText,
  confirmText,
  children,
}: UnknownItemsConfirmModalProps) => {
  const translations = useTranslations();
  const cancelRef = useRef(null);

  return (
    <Dialog
      leastDestructiveRef={cancelRef}
      isOpen={isOpen}
      onClose={handleClose}
      onConfirm={onConfirm}
      confirmText={confirmButtonText}
      cancelText={translations('cancel')}
      size="3xl"
      closeOnOverlayClick={false}
    >
      <ConfirmDialogBody confirmText={confirmText}>{children}</ConfirmDialogBody>
    </Dialog>
  );
};
